import mock from '../MockConfig';
import kmData from '@crema/services/db/apps/knowledgemanagement';
import { API } from 'shared/constants/AppEnums';
const token = sessionStorage.getItem('token')

const GET_LIST_CATEGORY = API.BASE_URL + 'mp/admin/category/?limit=10'
const GET_LIST_COMPETENCE = API.BASE_URL + 'mp/admin/competence/?limit=199'

mock.onGet('/km/activeusers').reply(200, kmData);

export const getListCategory = async () => {
    try {
        const response = await fetch(GET_LIST_CATEGORY, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json();
    } catch (error) {
        return error
    }
}

export const getListCompetence = async () => {
    try {
        const response = await fetch(GET_LIST_COMPETENCE, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putCancelApprove = async (id) => {
    try {
        const response = await fetch(API.ADMINPENILAIANCANCEL.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putCancelArticle = async (id) => {
    try {
        const response = await fetch(API.ADMINPENILAIANTAKEDOWN.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}